import IDream from "motw_core/Entity/IDream";
import * as React from "react";
import { WithAnimatedProgressBarAsync } from "source/app/presentation/Header/ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import DreamHelpers, {
    ExtendDream,
} from "source/app/presentation/MainPanel/Dreams/DreamHelpers/DreamHelpers";
import { IDreamsState } from "source/app/presentation/MainPanel/Dreams/IDreamsState";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Data from "source/app/services/Data";
import Nameof from "source/app/services/NameOf";
import { EDragDropObject } from "source/app/services/Shared/EDragDropObject";
import { useDropTarget } from "source/app/services/Shared/Hooks/useDropTarget";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import { ILogState } from "../../../Log/ILogState";
import { EDA } from "motw_core/Dreams/EDreamAttribute";
import { Sounds } from "source/app/services/Sound/Sounds";
const localStyles = require("../DreamRow.css");

export function DreamCompleteDropTarget({ dream }: { dream: IDream }) {
    const dropTargetResult = useDropTarget<IDream>(
        [EDragDropObject.dreamRow],
        CompleteDreamAsync
    );

    if (
        !dropTargetResult.isDragging ||
        dropTargetResult.draggedObject.id !== dream.id ||
        ExtendDream(dream).HasAttribute(EDA.decision)
    ) {
        return null;
    }

    return (
        <span
            ref={dropTargetResult.dropTargetRef}
            className={`${localStyles.dropTarget} ${localStyles.dropTargetComplete}`}
            data-is-over={dropTargetResult.isOver}
        >
            <IconWithText
                iconSuffix={EGlyphicon.ok}
                whenClicked={() => {}}
                displayAsBlock={false}
            >
                Complete
            </IconWithText>
        </span>
    );
}

export async function CompleteDreamAsync(dream: IDream) {
    const dreams = State.ReadClass<IDreamsState>(ESharedComponent.Dreams);
    const allLinks = DreamHelpers.GetAllLinks(dream, dreams.state.sortedData);

    return WithAnimatedProgressBarAsync(async () => {
        Sounds.shoutWhoo.Play();
        await DreamHelpers.DeleteDream(dream, allLinks, false, true);
        await Data.Load.Single.ByStateTarget(Nameof<ILogState>("logData"));
    });
}
